import {
  faBackward,
  faDoorOpen,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./ClubsDetail.css";

interface ClubsDetailProps {}

const ClubsDetail: FC<ClubsDetailProps> = () => {
  const { id } = useParams();
  const [club, setClub] = useState<any>(null);

  useEffect(() => {
    fetch("https://api.deceit.dev/clubs")
      .then((res) => res.json())
      .then((data) => {
        const matchedClub = data.find((club: any) => club.Id === id);
        setClub(matchedClub);
      });
  }, [id]);

  if (!club) return <div className="text-white">Loading...</div>;

  return (
    <div className="text-white">
      <h1 className="text-3xl font-bold mb-2">
        <Link to={"/clubs"}>
          <h1 className="inline opacity-70 font-normal hover:opacity-100 hover:cursor-pointer">
            Clubs {">"}
          </h1>{" "}
        </Link>
        {club.Name}
      </h1>
      <img
        src={
          club.ProfilePicture
            ? `https://se-images.campuslabs.ca/clink/images/${club.ProfilePicture}?preset=large-sq`
            : `https://se-images.campuslabs.ca/clink/images/9188f860-9ef4-4be5-978c-3ba4b792677e93b99350-90f7-4bd0-a73d-e010865272f5.jpg?preset=large-sq`
        }
        alt={club.Name}
        className="w-40 h-40 object-cover mb-4"
      />
      {club.CategoryNames?.map((category: string) => (
        <div
          key={category}
          className="text-xs inline-block bg-green-300 text-blue-950 font-bold px-2 py-1 rounded-sm mr-2"
        >
          {category}
        </div>
      ))}
      <p className="mb-4 mt-3">{club.Summary}</p>
      <hr className="opacity-40 mb-4" />
      <h1 className="text-3xl font-bold mb-2">Description</h1>
      <div
        className="text-gray-200"
        dangerouslySetInnerHTML={{ __html: club.Description }}
      />

      <a
        href={`https://sheridancollege.campuslabs.ca/engage/organization/${encodeURIComponent(club.WebsiteKey)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 inline-block bg-green-400 hover:bg-green-300 text-slate-950 font-bold px-4 py-2 rounded-sm"
      >
        <FontAwesomeIcon icon={faLink} /> Visit Club Page
      </a>

      <Link
        to={`/clubs`}
        className="mt-6 inline-block ml-2 bg-green-400 hover:bg-green-300 text-slate-950 font-bold px-4 py-2 rounded-sm"
      >
        <FontAwesomeIcon icon={faDoorOpen} /> Go back
      </Link>
    </div>
  );
};

export default ClubsDetail;
